import axios from 'axios'


const BASE_URL = ''

export default {
  state: {
    sessions: []
  },

  actions: {
    async getSessions({ commit }) {
      axios.get(BASE_URL + '/api/getSessions')
        .then(res => {
          commit('updateSessions', res.data)
        })
        .catch(e => {
          commit('updateSessions', [])
        })
    },

    async removeSession({ state, commit }, id) {
      axios.post(BASE_URL + '/api/stopSession', { id: id })
        .then(res => {
          commit('updateSessions', state.sessions.filter(e => e.id !== id))
        })
    }
  },

  mutations: {
    updateSessions(state, sessions) {

      state.sessions = sessions
    }
  },

  getters: {
    getSessions(s) {
      return s.sessions
    }
  }
}
